import React from 'react';

import classNames from 'classnames';

import ReduxConnect from 'Demora/redux-connect';

import formInModal from 'Demora/modals/formInModal';

import socialHttp from 'resources/../vendor/z5internet/react-social/src/resources/assets/js/src/utils/socialHttp';

class SendMessageButton extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	sendMessageModal() {
		formInModal({
			id: 'sendMessage',
			header: 'Send message',
			form: {
				fields: [
					{
						name: 'message',
						label: '',
						placeHolder: 'What do you want to write?',
						inputType: 'textarea',
						dataType: 'string',
						helpMessage: 'Type the message you want to send',
						required: true,
					},
				],
				button: {
					text: 'Send!',
					class: 'btn-primary',
					position: 'right',
				},
				labelsAboveFields: true,
				submit: this.sendMessage.bind(this),
				clearFormAfterSubmit: true,
			},
		});
	}

	sendMessage(vals) {
		return socialHttp('post', '/data/messages', {
			text: [
				{
					m: {
						m: vals.message,
					},
					jid: new Date().getTime(),
				},
			],
			ids: [this.props.obj],
		})
			.then((data) => {
				formInModal.close('sendMessage');

				if (this.props.messageSent) {
					this.props.messageSent();
				}
			})
			.catch((e) => {
				throw e;
			});
	}

	render() {
		const { users } = this.props;

		let user = this.props.user;

		if (!user || user.id + '-u' == this.props.obj) {
			return null;
		}

		let button = this.props.buttonText;

		if (!button) {
			button = 'Send message';
		}

		return (
			<button
				type='button'
				onClick={this.sendMessageModal.bind(this)}
				className={classNames('btn btn-primary', this.props.className)}
			>
				<i className='fa fa-envelope' style={{ minWidth: '20px' }}></i>&nbsp;
				<span
					className='d-none d-sm-inline-block'
					style={{ minWidth: '115px' }}
				>
					{button}
				</span>
			</button>
		);
	}
}

export default ReduxConnect(SendMessageButton, {
	user: 'user',
	users: 'users',
	feed: 'feed',
});
